import { render } from "./TF2ProjectReport.vue?vue&type=template&id=7c894904&scoped=true"
import script from "./TF2ProjectReport.vue?vue&type=script&lang=js"
export * from "./TF2ProjectReport.vue?vue&type=script&lang=js"

import "./TF2ProjectReport.vue?vue&type=style&index=0&id=7c894904&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c894904"]])

export default __exports__